import React, { useEffect, useState } from "react";
import { TranslationService } from "../../../services/TranslationService";
import AccountService, { Tax } from "../../../services/AccountService";

const initState = { name: "-", address: "-", taxNumber: "-" };

export const InvoiceData = () => {
  const [data, setData] = useState<Tax>(initState);
  const [dataResponse, setDataResponse] = useState<Tax>(initState);
  const [changingData, setChangingData] = useState(false);

  const handleChangeData = () => setChangingData((p) => !p);

  const loadData = async () => {
    const result = await AccountService.getTaxesDataUser();
    if (result instanceof Error) {
      return;
    }
    setData(result);
    setDataResponse(result);
  };

  const changeDataTaxes = async () => {
    const result = await AccountService.setTaxesDataUser(data);
    if (result instanceof Error) {
      return;
    }
    loadData();
    handleChangeData();
  };

  const handleInputChange = ({
    target: { name, value }
  }: React.ChangeEvent<HTMLInputElement>) =>
    setData((prevState) => ({ ...prevState, [name]: value }));

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div className="d-flex align-items-center gap-3">
        <h4 className="mb-2">{TranslationService.translate.InvoicingData}</h4>
        {!changingData ? (
          <i className="far fa-pen pointer" onClick={handleChangeData}></i>
        ) : (
          <i
            className="fa-fw fa-solid fa-times text-danger pointer"
            onClick={handleChangeData}
          />
        )}
      </div>
      <div className="card">
        <div className="card-body">
          {changingData ? (
            <>
              <div className="row">
                <div className="col mb-3">
                  <label className="font-weight-normal col-form-label">
                    {TranslationService.translate.Name}
                  </label>
                  <input
                    type="text"
                    name="name"
                    onChange={handleInputChange}
                    className="form-control"
                    defaultValue={dataResponse?.name}
                  />
                </div>
                <div className="col mb-3">
                  <label className="font-weight-normal col-form-label">
                    {TranslationService.translate.TaxId}
                  </label>
                  <input
                    type="text"
                    name="taxNumber"
                    onChange={handleInputChange}
                    className="form-control"
                    defaultValue={dataResponse?.taxNumber}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col mb-3">
                  <label className="font-weight-normal col-form-label">
                    {TranslationService.translate.Address}
                  </label>
                  <textarea
                    className="form-control"
                    onChange={(event) =>
                      setData((prev) => ({
                        ...prev,
                        address: event.target.value
                      }))
                    }
                    defaultValue={dataResponse?.address}
                    style={{ resize: "none" }}
                    rows={6}
                    spellCheck={false}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    data-gramm="false"
                    data-gramm_editor="false"
                    data-enable-grammarly="false"
                    translate="no"
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row mb-2">
                <label className="col-3 me-1">
                  {TranslationService.translate.Name}:
                </label>
                {dataResponse?.name}
              </div>
              <div className="row mb-2">
                <label className="col-3 me-1">
                  {TranslationService.translate.TaxId}:
                </label>
                {dataResponse?.taxNumber}
              </div>
              <div className="row mb-2">
                <label className="col-3 me-1">
                  {TranslationService.translate.Address}:
                </label>
                {dataResponse?.address}
              </div>
            </>
          )}

          <div className="mb-2 d-flex justify-content-end">
            {changingData ? (
              <div className="d-flex gap-2">
                <button
                  className="col btn btn-primary mt-2"
                  onClick={changeDataTaxes}
                >
                  {TranslationService.translate.Save}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
